var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"third-access"},[(_vm.showError)?[_c('div',{staticClass:"access-result"},[_vm._v("登录失败！")]),_c('div',{staticClass:"access-tip"},[_vm._v(" "+_vm._s(_vm.errorMessage || '请回到业务系统重新点击云采购进行跳转')+" ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }